const getters = {
  token: state => state.user.token,
  isLogin: state => state.user.isLogin,
  aboutUsId: state => state.user.aboutUsId,
  announcementId: state => state.user.announcementId,
  phoneNumber: state => state.user.phoneNumber,
  userName: state => state.user.userName,
  miniProgramPersonId: state => state.user.miniProgramPersonId,
  profilePhoto: state => state.user.profilePhoto,
  auditStatus: state => state.user.auditStatus,
  functionalStatus: state => state.user.functionalStatus,
}
export default getters
